<template>
  <div>
    <!-- header start -->
    <van-nav-bar
      title="提现明细"
      left-arrow
      :border="false"
      @click-left="goBack"
      :safe-area-inset-top="true"
      fixed
      :placeholder="true"
      :z-index="99"
    />
    <!-- header end -->

    <van-tabs
      sticky
      z-index="999"
      offset-top="46"
      :border="false"
      :swipe-threshold="4"
      color="#24a378"
      title-active-color="#24a378"
      line-height="4px"
    >
      <van-tab title="全部">
        <withdrawalItem></withdrawalItem>
      </van-tab>
      <van-tab title="待审核">
        <withdrawalItem :asId="0" ></withdrawalItem>
      </van-tab>
      <van-tab title="已完成">
        <withdrawalItem :asId="1" ></withdrawalItem>
      </van-tab>
      <van-tab title="已失败">
        <withdrawalItem :asId="2" ></withdrawalItem>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import withdrawalItem from "../../../components/WithdrawalItem.vue";

export default {
  data() {
    return {};
  },
  components: {
    withdrawalItem
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.drawal-item {
  display: flex;
  align-items: center;
  padding: 15px;
  .th {
    margin-right: 15px;
    .thumb {
      width: 30px;
      height: 30px;
      object-fit: contain;
    }
  }
  .bd {
    flex: 1;
    overflow: hidden;
    .thead {
      overflow: hidden;
      display: flex;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .name {
        font-size: 16px;
        color: #414141;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .status {
        font-size: 14px;
        margin-left: 10px;
      }
    }
    .date {
      font-size: 12px;
      color: #a1a1a1;
      margin-top: 4px;
    }
  }
  .ft {
    margin-left: 15px;
    font-size: 21px;
  }
  &.success {
    .status {
      color: #aeaeae;
    }
    .ft {
      color: #414141;
    }
  }
  &.wait {
    .status,
    .ft {
      color: green;
    }
  }
  &.failed {
    .status,
    .ft {
      color: red;
    }
  }
}
</style>
